function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".order-history_svg__cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:.25px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "order-history_svg__cls-1",
  d: "M7.807 9.718V1.982C7.807.968 8.63.147 9.642.147M2.425 9.718V1.982C2.425.968 3.246.147 4.26.147M5.972 11.553a1.835 1.835 0 01-1.835-1.835H.223c0 1.014.822 1.835 1.835 1.835"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "order-history_svg__cls-1",
  d: "M2.058 11.553h3.914a1.835 1.835 0 001.835-1.835V1.982"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "order-history_svg__cls-1",
  d: "M4.26.147h5.382c1.013 0 1.835.821 1.835 1.835v1.365h-3.67M3.342 3.918h3.425M3.342 6.202h3.425"
});

function SvgOrderHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "order-history_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgOrderHistory;